import { z } from 'zod';

import { ApiVonaZod } from './ApiVona';

export const GetCurrentVonasResponseZod = z.object({
  vonas: z.array(ApiVonaZod),
});
